import isObject$1 from './is-object.mjs';

var isObject = isObject$1;

var isPossiblePrototype = function (argument) {
  return isObject(argument) || argument === null;
};

export { isPossiblePrototype as default };
